var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._t("handle")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}]},[_vm._t("dropdown")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }